import { ReactNode, useState } from 'react'

import { gt } from '~/locale'

import { MenuButton, Wrapper } from './CollapsibleMenuShards'

type CollapsibleMenuProps = {
  children: ReactNode
}

export const CollapsibleMenu = ({ children }: CollapsibleMenuProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Wrapper>
      <MenuButton onClick={() => setIsOpen(open => !open)}>
        {isOpen ? gt.tp('RestaurantPage', 'Hide the menu') : gt.tp('RestaurantPage', 'See the menu')}
      </MenuButton>
      {isOpen && children}
    </Wrapper>
  )
}
